'use client';
import Link from 'next/link';
import React, { useEffect, useRef, useState } from 'react';
import NavbarIcon from '../components/common/responsive-navbat/navbar-icon';
import { useSession } from '@/hooks';

const Navbar = () => {
  const [open, setOpen] = useState('');
  const [hasValidSession, setHasValidSession] = useState(false);
  const modalRef = useRef<HTMLDivElement>(null);
  const { session, validateSession } = useSession();

  useEffect(() => {
    let isMounted = true;

    const syncSession = async () => {
      const hasStoredToken =
        typeof window !== 'undefined' && !!localStorage.getItem('token');

      if (!hasStoredToken) {
        if (isMounted) {
          setHasValidSession(false);
        }
        return;
      }

      const isValid = await validateSession();
      if (isMounted) {
        setHasValidSession(isValid);
      }
    };

    syncSession();

    return () => {
      isMounted = false;
    };
  }, [validateSession]);

  useEffect(() => {
    if (!session?.user?.id) {
      setHasValidSession(false);
    }
  }, [session]);

  // Disable clicks outside the modal
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target as Node)
      ) {
        setOpen('');
        event.stopPropagation();
        event.preventDefault();
      }
    };

    if (open) {
      document.addEventListener('click', handleClickOutside, true);
    }

    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [open]);
  return (
    <div className="border-b border-b-[#E5E5E5] px-4 py-6 text-[#253650] xl:px-0">
      <div className="m-auto flex max-w-[1280px] items-center justify-between">
        <div className="">
          <Link href={'/'} className="text-[28px] font-bold leading-7">
            Logo
          </Link>
        </div>
        <div className="hidden items-center gap-[21px] lg:flex">
       
          {hasValidSession ? (
            <a
              className={`rounded-lg border border-[#4B70F5] px-4 py-3 text-base leading-[16px] text-[#4B70F5] hover:bg-[#4b70f5] hover:text-white`}
              href={'/portal/dashboard'}>
              Dashboard
            </a>
          ) : (
            <a
              className={`rounded-lg border border-[#4B70F5] px-4 py-3 text-base leading-[16px] text-[#4B70F5] hover:bg-[#4b70f5] hover:text-white`}
              href={'/auth/signin'}>
              LOGIN
            </a>
          )}
        </div>
        <NavbarIcon isLoggedIn={hasValidSession} />
      </div>
    </div>
  );
};

export default Navbar;
